import { useMemo } from 'react'
import { RiInformationLine, RiArrowUpSLine } from 'react-icons/ri'

// Panduan visual pakai gambar asli dari frontend — desain disesuaikan dengan layout asli di landingpage
const GUIDE_DATA = [
  {
    slug: 'hero_background',
    title: 'Background Halaman Utama (Hero)',
    description:
      'Gambar tampil sebagai latar full-screen di bagian teratas website. Bergilir otomatis setiap 6 detik dengan efek flash putih. Judul "Asa Hikari Mulya" tampil di tengah atas gambar dengan overlay gelap.',
    preview: (
      <div className="relative aspect-video overflow-hidden rounded-t-lg bg-gray-900">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('/assets/bg1.jpg')` }} />
        <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.5)' }} />

        {/* Side banner (left, matches HeroSection) */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 -rotate-90 origin-right bg-blue-600 text-white px-2 py-0.5 text-[8px] font-semibold whitespace-nowrap rounded-r">
          ASA HIKARI MULYA 2025
        </div>

        {/* Hero content — matches HeroSection */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="h-px w-8 bg-white opacity-20" />
            <div className="text-lg font-bold leading-tight">
              <div>Asa</div><div>Hikari</div><div>Mulya</div>
            </div>
            <div className="h-px w-8 bg-white opacity-20" />
          </div>
          <p className="text-[9px] italic max-w-[200px] leading-tight opacity-90">
            &quot;Kami siap memberikan bimbingan dan segala hal yang perlu Anda ketahui untuk mempersiapkan diri bekerja di Jepang&quot;
          </p>
          <p className="mt-1 max-w-[250px] text-[7px] leading-tight opacity-70">
            Asa Hikari Mulya adalah pusat pelatihan bahasa Jepang terpercaya...
          </p>
          <button className="mt-2 rounded-bl-xl rounded-tr-xl bg-blue-800 px-4 py-1 text-[9px] font-semibold opacity-80">
            Join Now
          </button>
        </div>

        {/* Highlight frame */}
        <div className="absolute inset-0 border-[2px] border-dashed border-yellow-400 rounded-t-lg pointer-events-none" />
        <div className="absolute right-2 top-2 flex items-center gap-0.5 rounded bg-yellow-400 px-2 py-0.5 text-[9px] font-bold text-gray-900 shadow">
          <RiArrowUpSLine className="inline" /> Latar belakang ini yang diganti
        </div>

        {/* Carousel dots */}
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
          {[0,1,2,3].map((i) => (
            <div key={i} className={`rounded-full ${i === 0 ? 'w-4 h-1 bg-white' : 'w-1 h-1 bg-white/40'}`} />
          ))}
        </div>
      </div>
    ),
  },

  {
    slug: 'team_photo',
    title: 'Foto Marketing / Tim ("Talenta Terbaik Kami")',
    description:
      'Kartu profil tim marketing tampil dalam carousel: gambar profil di atas, badge "Marketing", nama, dan visi. Desktop menampilkan 3 kartu sekaligus. Mobile 1 kartu. Bergilir otomatis setiap 3 detik dengan progress dots.',
    preview: (
      <div className="relative aspect-video overflow-hidden rounded-t-lg bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-50 flex items-center justify-center p-3">
        {/* Connection line (desktop) */}
        <div className="absolute left-12 right-12 top-[5.5rem] h-px bg-gradient-to-r from-transparent via-blue-300 to-transparent z-0" />

        <div className="flex items-center justify-center gap-2 w-full">
          {/* Left card (dim) */}
          <div className="flex-shrink-0 w-[18%] rounded-2xl border bg-white/80 shadow overflow-hidden opacity-40">
            <div className="aspect-square">
              <img src="/assets/foto_diri_formal_689c4047bec90.jpg" alt="" className="w-full h-full object-cover" />
            </div>
            <div className="p-1.5">
              <div className="rounded-md bg-blue-50 px-1 py-0.5 text-center text-[6px] font-semibold text-blue-600">Marketing</div>
              <div className="mt-0.5 text-center text-[7px] font-bold text-gray-800">UDIN, S.Sos.I</div>
              <div className="mt-0.5 text-center text-[5px] text-gray-500 italic">"Menampung siswa..."</div>
            </div>
          </div>

          {/* Center card (highlighted) */}
          <div className="relative flex-shrink-0 w-[22%] rounded-2xl bg-white shadow-xl overflow-hidden ring-2 ring-yellow-400/50 scale-105">
            <div className="aspect-square">
              <img src="/assets/foto_diri_formal_68be5d7aa8d2b.jpeg" alt="" className="w-full h-full object-cover" />
            </div>
            <div className="absolute right-1 top-1 rounded bg-yellow-400 px-1 text-[6px] font-bold text-gray-900 shadow">INI</div>
            <div className="p-1.5">
              <div className="rounded-md bg-blue-50 px-1 py-0.5 text-center text-[6px] font-semibold text-blue-600">Marketing</div>
              <div className="mt-0.5 text-center text-[7px] font-bold text-gray-800">RUSBIYANTO</div>
              <div className="mt-0.5 text-center text-[5px] text-gray-500 italic">"Ikut andil dalam..."</div>
            </div>
          </div>

          {/* Right card (dim) */}
          <div className="flex-shrink-0 w-[18%] rounded-2xl border bg-white/80 shadow overflow-hidden opacity-40">
            <div className="aspect-square">
              <img src="/assets/foto_diri_formal_68b1114c78dbf.jpg" alt="" className="w-full h-full object-cover" />
            </div>
            <div className="p-1.5">
              <div className="rounded-md bg-blue-50 px-1 py-0.5 text-center text-[6px] font-semibold text-blue-600">Marketing</div>
              <div className="mt-0.5 text-center text-[7px] font-bold text-gray-800">Arwindha</div>
              <div className="mt-0.5 text-center text-[5px] text-gray-500 italic">"Mendapat penghasilan..."</div>
            </div>
          </div>
        </div>

        {/* Number badges */}
        <div className="absolute top-1 left-[28%] w-5 h-5 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-[7px] text-white shadow">02</div>
        <div className="absolute top-1 left-[52%] w-6 h-6 rounded-full bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center text-[7px] text-white shadow ring-2 ring-yellow-300">04</div>
        <div className="absolute top-1 left-[74%] w-5 h-5 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-[7px] text-white shadow">03</div>

        {/* Progress dots */}
        <div className="absolute bottom-1.5 left-1/2 -translate-x-1/2 flex gap-1">
          <div className="h-1.5 w-1.5 rounded-full bg-gray-300" />
          <div className="h-1.5 w-1.5 rounded-full bg-gray-300" />
          <div className="h-1.5 w-5 rounded-full bg-blue-600" />
          <div className="h-1.5 w-1.5 rounded-full bg-gray-300" />
        </div>
      </div>
    ),
  },

  {
    slug: 'about_image',
    title: 'Gambar About / Tentang Kami',
    description:
      'Layout kolom 2 di section About: kiri atas & bawah = 2 gambar kecil. Kanan = 1 gambar besar (landscape). Desktop: grid 2 kolom. Mobile: gambar besar di atas, 2 kecil di bawah (grid 2 kolom). Semua gambar rounded + shadow.',
    preview: (
      <div className="relative aspect-video overflow-hidden rounded-t-lg bg-gray-50 p-4">
        {/* Desktop tablet layout — matches AboutSection.jsx md:grid-cols-2 */}
        <div className="grid grid-cols-2 gap-3 h-full items-center">
          {/* Left: two small stacked with top offset (matches the mt-32 sm:mt-80 feel) */}
          <div className="flex flex-col gap-2 h-full justify-center">
            <div className="relative rounded-lg overflow-hidden shadow-lg border-2 border-yellow-400 hover:scale-110 transition-transform">
              <img src="/assets/bg1.jpg" alt="" className="h-20 w-full object-cover rounded-tl-[1rem]" />
              <div className="absolute right-1 top-0.5 rounded bg-yellow-400 px-1 text-[6px] font-bold text-gray-900">#2 kecil atas</div>
            </div>
            <div className="relative rounded-lg overflow-hidden shadow-lg border-2 border-yellow-400 hover:scale-110 transition-transform">
              <img src="/assets/bg4.jpg" alt="" className="h-20 w-full object-cover rounded-br-[1rem]" />
              <div className="absolute right-1 top-0.5 rounded bg-yellow-400 px-1 text-[6px] font-bold text-gray-900">#3 kecil bawah</div>
            </div>
          </div>
          {/* Right: big image */}
          <div className="relative h-full flex justify-center items-center">
            <div className="relative rounded-xl overflow-hidden shadow-lg border-2 border-yellow-400 hover:scale-110 transition-transform w-full">
              <img src="/assets/img_panjang.jpg" alt="" className="w-full h-full object-cover rounded-xl" />
              <div className="absolute right-1 top-0.5 rounded bg-yellow-400 px-1 text-[6px] font-bold text-gray-900">#1 besar</div>
            </div>
          </div>
        </div>

        {/* Text area overlay (left side, as in real AboutSection) */}
        <div className="absolute left-1 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur-sm rounded-lg p-2 w-[35%] shadow opacity-80 hidden lg:block">
          <div className="text-[6px] font-bold text-gray-800">About <span className="text-blue-600">ASA HIKARI MULYA</span></div>
          <div className="mt-0.5 text-[5px] text-gray-500">Misi Kami Menjadi Jembatan Karir Anda...</div>
          <div className="mt-1 flex items-center gap-1">
            <div className="h-1.5 w-3 rounded bg-blue-600" />
            <div className="text-[5px] text-blue-600">Kurikulum Terstandar</div>
          </div>
        </div>
      </div>
    ),
  },

  {
    slug: 'logo',
    title: 'Logo Header & Footer',
    description:
      'Logo tampil di dua tempat: (1) Header navigasi — versi gelap saat sudah di-scroll, versi terang saat di atas hero. (2) Footer. Header logo juga berganti ukuran saat scroll (w-11→w-14).',
    preview: (
      <div className="relative aspect-video overflow-hidden rounded-t-lg bg-white">
        {/* Header bar — matches Header.jsx scrolled state */}
        <div className="relative bg-white shadow-sm px-3 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="relative h-8 w-8 rounded-md overflow-hidden border-2 border-dashed border-yellow-400">
              <img src="/assets/logo_dark.png" alt="Logo" className="h-full w-full object-contain" />
              <div className="absolute -right-1 -top-1 rounded-full bg-yellow-400 w-2.5 h-2.5 flex items-center justify-center">
                <span className="text-[5px] font-bold text-gray-900">!</span>
              </div>
            </div>
            <div className="text-[9px] font-bold text-gray-800">Asa Hikari Mulya</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="h-1 w-5 rounded bg-gray-200" />
            <div className="h-1 w-5 rounded bg-gray-200" />
            <div className="rounded-full bg-blue-600 h-3.5 w-8" />
          </div>
        </div>

        {/* Hero background with transparent header version */}
        <div className="relative">
          <img src="/assets/bg1.jpg" alt="" className="w-full h-24 object-cover" />
          <div className="absolute inset-0 bg-black/30" />
          <div className="absolute top-2 left-3 flex items-center gap-2 rounded-md px-2 py-1">
            <img src="/assets/logo_bg.png" alt="Logo" className="h-6 object-contain" />
            <span className="text-[9px] font-bold text-white">Asa Hikari Mulya</span>
          </div>
        </div>

        <div className="absolute right-2 top-1 flex items-center gap-0.5 rounded bg-yellow-400 px-1.5 py-0.5 text-[7px] font-bold text-gray-900 z-10">
          <RiArrowUpSLine /> Ganti logo
        </div>
      </div>
    ),
  },

  {
    slug: 'gallery',
    title: 'Galeri Foto Kegiatan',
    description:
      'Grid 3 kolom (desktop) / 2 kolom (mobile) foto kegiatan. Setiap foto punya judul. Hover effect scale + shadow. Semua foto yang diaktifkan akan tampil di galeri.',
    preview: (
      <div className="relative aspect-video overflow-hidden rounded-t-lg bg-white p-2">
        <div className="grid grid-cols-3 gap-1.5 h-full">
          {[
            { src: '/assets/Job.jpeg', title: 'Job Fair di PCC', idx: 0 },
            { src: '/assets/Pengantaran.jpeg', title: 'Pengantaran Siswa', idx: 1 },
            { src: '/assets/Pengantaran2.jpeg', title: 'Pengantaran 2', idx: 2 },
            { src: '/assets/Persiapan.jpeg', title: 'Persiapan', idx: 3 },
            { src: '/assets/Pertemuan.jpeg', title: 'Pertemuan Pejabat', idx: 4 },
            { src: '/assets/Pembekalan.jpeg', title: 'Pembekalan', idx: 5 },
          ].map((item) => (
            <div key={item.idx} className={`relative group rounded-lg overflow-hidden ${
              item.idx < 2 ? 'ring-2 ring-yellow-400' : ''
            }`}>
              <img src={item.src} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              {/* Title overlay */}
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent px-1 py-0.5">
                <span className="text-[6px] text-white font-medium">{item.title}</span>
              </div>
              {item.idx < 2 && (
                <div className="absolute right-1 top-1 rounded bg-yellow-400 px-1 text-[6px] font-bold text-gray-900">
                  INI
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 rounded bg-black/50 px-1.5 py-0.5 text-[8px] text-white">
          Semua foto aktif tampil di galeri
        </div>
      </div>
    ),
  },

  {
    slug: 'client_logo',
    title: 'Logo Klien / Mitra',
    description:
      'Logo-logo mitra (IPNU, Kongres IPPNU) tampil di bagian klien. Ditampilkan dalam grid dengan efek hover scale.',
    preview: (
      <div className="relative aspect-video overflow-hidden rounded-t-lg bg-white flex items-center justify-center">
        <div className="grid grid-cols-2 gap-4 p-4">
          {[
            '/assets/log_ippnu_res.png',
            '/assets/log_kongres_ippnu.png',
          ].map((src, i) => (
            <div
              key={i}
              className={`flex items-center justify-center rounded-lg border p-3 transition-transform hover:scale-110 ${
                i === 0 ? 'border-2 border-yellow-400' : ''
              }`}
            >
              <img src={src} alt="Logo klien" className="max-h-12 object-contain" />
              {i === 0 && (
                <div className="absolute right-1 top-1 rounded bg-yellow-400 px-1 text-[6px] font-bold text-gray-900">INI</div>
              )}
            </div>
          ))}
        </div>
      </div>
    ),
  },
]

export default function TypeGuide({ typeSlug }) {
  const selected = useMemo(
    () => GUIDE_DATA.find((g) => g.slug === typeSlug),
    [typeSlug],
  )

  const items = selected ? [selected] : GUIDE_DATA

  return (
    <div className="space-y-3">
      {!selected && (
        <div className="rounded-lg border-l-4 border-sky-400 bg-sky-50 px-4 py-2">
          <p className="text-sm text-sky-800">
            <RiInformationLine className="mr-1 inline text-base text-sky-500" />
            Di bawah ini contoh nyata posisi setiap gambar di website. Pilih tipe gambar untuk melihat hanya panduan yang sesuai.
          </p>
        </div>
      )}

      <div className={`grid gap-4 ${items.length === 1 ? 'grid-cols-1' : 'sm:grid-cols-2'}`}>
        {items.map((item) => (
          <div key={item.slug} className="overflow-hidden rounded-lg border bg-background shadow-sm">
            {item.preview}
            <div className="border-t p-3">
              <h4 className="text-sm font-semibold">{item.title}</h4>
              <p className="mt-0.5 text-xs text-muted-foreground leading-relaxed">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
